import { Injectable } from '@angular/core';
import { UserJournal } from '../models/user-journal.model';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JournalService {
  error = new Subject<string>();
  slug = '/user_journals';
  resourceName = 'user_journals';
  allEntries?: Observable<UserJournal[]> | null = null;

  showJournal = new BehaviorSubject(false);
  activeArea = new BehaviorSubject('general');

  constructor(
    private http: HttpClient
  ) {}

  fetchAll(): Observable<UserJournal[]> {
    if (!this.allEntries) {
      this.allEntries = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: UserJournal[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                // parse the exercise data
                if (item.exercises) {
                  item.exercises = JSON.parse(item.exercises);
                }
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allEntries;
  }

  clearCache() {
    this.allEntries = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          const item = new UserJournal(
            +responseData.user_eat_well_id,
            +responseData.user_id,
            responseData.area,
            responseData.notes,
            responseData.created,
            responseData.modified
          );
          return item;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(area: string, notes: string) {
    this.clearCache();
    const payload = {
      area,
      notes,
    };
    return this.http.post<UserJournal>(
      environment.apiUrl + this.slug,
      payload,
      {
        observe: 'response',
      }
    );
  }

  update(id: number, area: string, notes: string) {
    this.clearCache();
    const payload = {
      area,
      notes,
    };
    return this.http.patch<UserJournal>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  onShowJournal(area:string){
    this.showJournal.next(true);
    this.activeArea.next(area);
  }
}
